const flySearchRetailFilter = function() {
  return {
    id: 'flySearchRetailFilter',

    values: {},

    params: {
      excludedDates: {
        type: [String],
        name: 'excludedDates'
      },

      carriers: {
        type: [String],
        name: 'carriers'
      },

      includedCarriers: {
        type: [String],
        name: 'included-carriers'
      },

      excludedCarriers: {
        type: [String],
        name: 'excluded-carriers'
      },

      origAirports1: {
        type: [String],
        name: 'orig-airports1'
      },

      destAirports1: {
        type: [String],
        name: 'dest-airports1'
      },

      origAirports2: {
        type: [String],
        name: 'orig-airports2'
      },

      destAirports2: {
        type: [String],
        name: 'dest-airports2'
      },

      origAirports3: {
        type: [String],
        name: 'orig-airports3'
      },

      destAirports3: {
        type: [String],
        name: 'dest-airports3'
      },

      origAirports4: {
        type: [String],
        name: 'orig-airports4'
      },

      destAirports4: {
        type: [String],
        name: 'dest-airports4'
      },

      origAirports5: {
        type: [String],
        name: 'orig-airports5'
      },

      destAirports5: {
        type: [String],
        name: 'dest-airports5'
      },
      numOfStops: {
        type: String,
        name: 'num-of-stops',
        value: '7'
      },
      sort: {
        type: [String],
        name: 'sort'
      },

      // TODO: these should all be created dynamically
      departTimeStart1: {
        type: String,
        // persist: true,
        name: 'depart-time-start1'
      },

      departTimeEnd1: {
        type: String,
        // persist: true,
        name: 'depart-time-end1'
      },

      departTimeStart2: {
        type: String,
        // persist: true,
        name: 'depart-time-start2'
      },

      departTimeEnd2: {
        type: String,
        // persist: true,
        name: 'depart-time-end2'
      },

      departTimeStart3: {
        type: String,
        // persist: true,
        name: 'depart-time-start3'
      },

      departTimeEnd3: {
        type: String,
        // persist: true,
        name: 'depart-time-end3'
      },

      departTimeStart4: {
        type: String,
        // persist: true,
        name: 'depart-time-start4'
      },

      departTimeEnd4: {
        type: String,
        // persist: true,
        name: 'depart-time-end4'
      },

      departTimeStart5: {
        type: String,
        // persist: true,
        name: 'depart-time-start5'
      },

      departTimeEnd5: {
        type: String,
        // persist: true,
        name: 'depart-time-end5'
      },

      arriveTimeStart1: {
        type: String,
        // persist: true,
        name: 'arrive-time-start1'
      },

      arriveTimeEnd1: {
        type: String,
        // persist: true,
        name: 'arrive-time-end1'
      },

      arriveTimeStart2: {
        type: String,
        // persist: true,
        name: 'arrive-time-start2'
      },

      arriveTimeEnd2: {
        type: String,
        // persist: true,
        name: 'arrive-time-end2'
      },

      arriveTimeStart3: {
        type: String,
        // persist: true,
        name: 'arrive-time-start3'
      },

      arriveTimeEnd3: {
        type: String,
        // persist: true,
        name: 'arrive-time-end3'
      },

      arriveTimeStart4: {
        type: String,
        // persist: true,
        name: 'arrive-time-start4'
      },

      arriveTimeEnd4: {
        type: String,
        // persist: true,
        name: 'arrive-time-end4'
      },

      arriveTimeStart5: {
        type: String,
        // persist: true,
        name: 'arrive-time-start5'
      },

      arriveTimeEnd5: {
        type: String,
        // persist: true,
        name: 'arrive-time-end5'
      },

      layoverMin: {
        type: String,
        // persist: true,
        name: 'layover-min'
      },

      layoverMax: {
        type: String,
        // persist: true,
        name: 'layover-max'
      },

      sliceDurationMin1: {
        type: String,
        // persist: true,
        name: 'slice-duration-min1'
      },

      sliceDurationMax1: {
        type: String,
        // persist: true,
        name: 'slice-duration-max1'
      },

      sliceDurationMin2: {
        type: String,
        // persist: true,
        name: 'slice-duration-min2'
      },

      sliceDurationMax2: {
        type: String,
        // persist: true,
        name: 'slice-duration-max2'
      },

      sliceDurationMin3: {
        type: String,
        // persist: true,
        name: 'slice-duration-min3'
      },

      sliceDurationMax3: {
        type: String,
        // persist: true,
        name: 'slice-duration-max3'
      },

      sliceDurationMin4: {
        type: String,
        // persist: true,
        name: 'slice-duration-min4'
      },

      sliceDurationMax4: {
        type: String,
        // persist: true,
        name: 'slice-duration-max4'
      },

      sliceDurationMin5: {
        type: String,
        // persist: true,
        name: 'slice-duration-min5'
      },

      sliceDurationMax5: {
        type: String,
        // persist: true,
        name: 'slice-duration-max5'
      },

      preferredLayoverAirports1: {
        type: [String],
        name: 'slice-layover-airport1'
      },

      preferredLayoverAirports2: {
        type: [String],
        name: 'slice-layover-airport2'
      },

      preferredLayoverAirports3: {
        type: [String],
        name: 'slice-layover-airport3'
      },

      preferredLayoverAirports4: {
        type: [String],
        name: 'slice-layover-airport4'
      },

      preferredLayoverAirports5: {
        type: [String],
        name: 'slice-layover-airport5'
      }
    }
  }
}

export { flySearchRetailFilter }
